import { fetcher } from '@commenda/utils';

/** Re-reads a draft's status from the provider — heals an envelope left at CREATED by a closed sender view. */
export async function reconcileEnvelope(envelopeId: string): Promise<Response> {
  return fetcher(`e-signature/envelopes/${envelopeId}/reconcile`, {
    method: 'POST',
  });
}
